document.addEventListener('page:loaded', function() {
  const description = document.querySelector('.collection__description');
  const readMoreBtn = document.querySelector('.read-more-btn');

  if (description !== null){
    if (description.offsetHeight < description.scrollHeight) {
      readMoreBtn.style.display = 'block';
    }
    
    readMoreBtn.addEventListener('click', () => {
      description.classList.toggle('show-more');
      if (description.classList.contains('show-more')) {
        readMoreBtn.textContent = 'Show less';
      } else {
        readMoreBtn.textContent = 'Read more';
      }
    });
  }
});
